import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { CiSearch } from "react-icons/ci";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ResendInviteButton from '../Talent/ResendInviteButton';
import RegisteredVia from '../Talent/RegisteredVia';
import { useDebounceValue } from 'usehooks-ts';
import { useTalentsQuery } from '../../reactWrapper/endpoints/talent/talent.api';
import Pagination from '../Pagination/Pagination';
import Table from './Table';
import OutlineButton from '../Button/OutlineButton';


const TalentTable = () => {
  const siblingCount = 1;
  const pageColumn = 1;
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm] = useDebounceValue(searchTerm, 500);
  const { talents } = useTalentsQuery(page + 1, debouncedSearchTerm)
  const btnRef = useRef()

  const handlePageChange = useCallback(
    (page) => {
      setPage(page - 1);
    },
    [page]
  );

  // const isValidEmail = (email) => {
  //   const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  //   return emailRegex.test(email);
  // }

  const tableHeader = useMemo(
    () => [
      {
        title: 'First name',
        key: 'first-name',
      },
      {
        title: 'Last name',
        key: 'last-name',
      },
      {
        title: 'Phone',
        key: 'phone',
      },
      {
        title: 'Email',
        key: 'email',
      },
      {
        title: 'Registered via',
        key: 'registered-via',
      },
      {
        title: 'Date joined',
        key: 'date-joined',
      },
      {
        title: '',
        key: 'details',
      },
    ],
    []
  );

  const modifiedData = useMemo(() => {
    return talents?.data?.map((each) => [
      <p>{each?.firstName}</p>,
      <p>{each?.lastName}</p>,
      <p>{each?.phone}</p>,
      <p>{each?.email}</p>,
      <RegisteredVia talent={each} />,
      new Date(each?.created_at).toLocaleDateString(),
      <div className='flex items-center justify-end gap-2 whitespace-nowrap'>
        {/* Renders nothing unless this talent is still waiting on an invite
            an admin sent — see awaitingInvite. One who signed themselves up
            has a password of their own and nothing to resend. */}
        <ResendInviteButton talent={each} />
        <Link
          className='text-sm inline-block rounded-lg border border-border py-[1.56px] px-[11.7px] text-muted-foreground '
          to={`/matched-talents/cbt-profile/${each?.id}`}
        >
          Details
        </Link>
      </div>,
    ])
  })

  useEffect(() => {
    setTotalCount(talents?.total ?? 0);
  }, [talents]);

  return (
    <div className='w-full space-y-4'>
      {/* filter bar: the reference gives these their own p-4 card */}
      <section className="flex flex-col gap-3 rounded-2xl border bg-card p-4 shadow-ui-sm sm:flex-row sm:items-center">
        <section className="relative flex-1">
          <CiSearch
            size={18}
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
          <input
            id={"search-bar"}
            type="text"
            ref={btnRef}
            className="h-9 w-full rounded-md border border-input bg-transparent pl-9 pr-3 text-sm shadow-ui-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
            placeholder="Search by email, name or the job they applied for"
            onChange={e => {
              setSearchTerm(e.target.value)
            }}
          />
        </section>

        <OutlineButton
          onClick={() => {
            setSearchTerm('');
            if (btnRef?.current?.value) {
              btnRef.current.value = ''
            }
          }}
          label={'Reset'}
        />
      </section>

      <Table header={tableHeader} label="" column={modifiedData} />

      <section className="w-full">
        <Pagination
          rangeStart={
            totalCount !== 0
              ? (page || 0) * ((pageSize || 0) * pageColumn) + 1
              : 0
          }
          totalCount={totalCount}
          currentPage={(page || 0) + 1}
          pageSize={pageSize}
          pageColumn={pageColumn}
          siblingCount={siblingCount}
          onPageChange={handlePageChange}
          className="pt-9"
        />
      </section>

    </div>
  );
};

export default TalentTable;
